export default {
  root: {
    fontSize: '0.875rem',
    borderRadius: 8,
    lineHeight: 1.43
  }
};
